import React from 'react';
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-6 border-y border-border-light px-4 relative overflow-hidden" data-id="element-247">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-248"></div>

      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-6 text-center relative z-10" data-id="element-249">
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 w-full justify-around text-text-sec text-sm sm:text-base font-medium" data-id="element-250">
          <div className="flex flex-col items-center gap-1" data-id="element-251">
            <span className="font-serif font-black text-2xl text-primary" data-id="element-252">
              +15K
            </span>
            <span data-id="element-253">Professional instructors in our global network</span>
          </div>
          <div className="hidden sm:block w-px h-8 bg-border-light" data-id="element-254"></div>
          <div className="flex flex-col items-center gap-1" data-id="element-255">
            <span className="font-serif font-black text-2xl text-primary" data-id="element-256">
              1,200+
            </span>
            <span data-id="element-257">
              Boutique studios and Pilates centres using these sequences
            </span>
          </div>
          <div className="hidden sm:block w-px h-8 bg-border-light" data-id="element-258"></div>
          <div className="flex flex-col items-center gap-1" data-id="element-259">
            <span className="font-serif font-black text-2xl text-primary" data-id="element-260">
              380K+
            </span>
            <span data-id="element-261">Class routines downloaded this year</span>
          </div>
          <div className="hidden sm:block w-px h-8 bg-border-light" data-id="element-262"></div>
          <div className="flex flex-col items-center gap-1" data-id="element-263">
            <span className="font-serif font-black text-2xl text-primary" data-id="element-264">
              94%
            </span>
            <span data-id="element-265">Save 5+ hours of planning every week</span>
          </div>
        </div>
      </div>
    </section>;
}